"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAgencyOpenTime = void 0;
const libs_utils_1 = require("@hotelplan/libs.utils");
const agencyOpeningTimes_utils_1 = require("./agencyOpeningTimes.utils");
const getCurrentOpeningHours_1 = require("./getCurrentOpeningHours");
function dateTupleToShift([from, to], timeZone) {
    return {
        from: (0, agencyOpeningTimes_utils_1.dateToTimeString)(from, timeZone),
        to: (0, agencyOpeningTimes_utils_1.dateToTimeString)(to, timeZone),
    };
}
function getNextOpeningHours(openingHours, timeZone, currentDate, language) {
    var _a;
    for (let delta = 1; delta <= 7; delta++) {
        const nextDate = (0, libs_utils_1.addDays)(currentDate, delta);
        const nextOpeningHours = (0, getCurrentOpeningHours_1.getCurrentOpeningHours)(openingHours, nextDate, {
            language,
            timeZone,
        });
        if (nextOpeningHours.open && ((_a = nextOpeningHours.shifts) === null || _a === void 0 ? void 0 : _a.length)) {
            return {
                day: nextDate,
                shifts: nextOpeningHours.shifts.map(shift => [
                    ...(0, agencyOpeningTimes_utils_1.shiftToDateTuple)(shift, timeZone, currentDate),
                ]),
            };
        }
    }
}
function getAgencyOpenTime(openingHours, timeZone, currentDate, language) {
    const todayOpeningHours = (0, getCurrentOpeningHours_1.getCurrentOpeningHours)(openingHours, currentDate, {
        language,
        timeZone,
    });
    const todayComingShifts = todayOpeningHours.shifts
        .map(shift => (0, agencyOpeningTimes_utils_1.shiftToDateTuple)(shift, timeZone, currentDate))
        .filter(([from]) => from.getTime() > currentDate.getTime());
    if (todayComingShifts.length) {
        return {
            shifts: todayComingShifts.map(dateTuple => dateTupleToShift([...dateTuple], timeZone)),
        };
    }
    else {
        const { shifts, day } = getNextOpeningHours(openingHours, timeZone, currentDate, language);
        return {
            shifts: shifts.map(dateTuple => dateTupleToShift([...dateTuple], timeZone)),
            day: (0, libs_utils_1.formatDateInTimeZone)(day, 'EEEE', language, timeZone),
        };
    }
}
exports.getAgencyOpenTime = getAgencyOpenTime;
//# sourceMappingURL=getAgencyOpenTime.js.map